// extracted by mini-css-extract-plugin
export default {"imageWrapper":"kZ-z","hovered":"lZ-z","hoverImage":"mZ-z","mainImage":"nZ-z","imageNoBackground":"oZ-z","fullSizeImage":"pZ-z"};